import React from "react";
import { withNavBars } from "../../HOCs";
import ServiceProviderView from "./serviceProviderView";

class ServiceProviderViewParent extends React.Component {
  render() {
    return <ServiceProviderView />;
  }
}

const props = {
  boxShadow: false
}

export default withNavBars(ServiceProviderViewParent, props);
